import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { isNull } from "@/functions/Util";

export default class MaoObraAlocadaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }
    
    validate(model, refs) {
        let validated = true;
        
        if (isNull(model.idcargo)) {
            refs.cargoInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message("error", 'msg-selecionar-cargo', true));
        }
        if (isNull(model.tipoCobranca)) {
            refs.tipoCobrancaInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message("error", 'msg-selecionar-tipo-cobranca', true));
        }
        if (isNull(model.tipoAlocacao)) {
            refs.tipoAlocacaoInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message("error", 'msg-selecionar-tipo-alocacao', true));
        }
        return validated;
    }
}